module.exports = __webpack_public_path__ + "media/question4_au.93bd3f77.mp3";